import React, { Component } from "react";

import {Link} from "react-router-dom";

class BottomNav extends Component {
    constructor(props) {
        super(props)
        this.state = {
            varPais: this.props.varPais,
            idPais: this.props.idPais,
            keyTok: this.props.keyTok,
            urlPais: this.props.urlPais 
        };
    }
    render() {
        return(
            <nav className="navbar fixed-bottom navbar-light bg-light clubes--bottom-nav d-print-flex d-lg-none d-md-none">
                <Link to={this.state.varPais}>
                    <div className="clubes--home-icon"></div>
                </Link>
                <Link to={ { pathname: this.state.varPais+'eventos-bodas', state: this.state }}>
                    <div className="clubes--boda-icon"></div>
                </Link>
                <Link to={ { pathname: this.state.varPais+'eventos-regalos', state: this.state }}>
                    <div className="clubes--regalo-icon"></div>
                </Link>
                <div className="clubes--pais-icon">{ this.state.varPais.replace('/', "").replace('/', "")}</div>
            </nav>
        )
    }
}

export default BottomNav;